import { createRoot } from 'react-dom/client';
import React, { StrictMode, Suspense } from 'react';
import { KatSpinner } from '@amzn/katal-react';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import { ErrorBoundary } from './components/general/ErrorBoundary';
import './logger';

import '@amzn/katal-components/styles.css';
import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <AppInitWrapper>
        <Suspense fallback={<KatSpinner size="large" />}>
          <App />
        </Suspense>
      </AppInitWrapper>
    </ErrorBoundary>
  </StrictMode>,
);
